import { render, staticRenderFns } from "./member_ios.vue?vue&type=template&id=309f8b9b&scoped=true"
import script from "./member_ios.vue?vue&type=script&lang=js"
export * from "./member_ios.vue?vue&type=script&lang=js"
import style0 from "./member_ios.vue?vue&type=style&index=0&id=309f8b9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309f8b9b",
  null
  
)

export default component.exports